import { inject, Injectable } from '@angular/core';
import { WINDOW } from '@any2any/shared';
import { v4 as uuidv4 } from 'uuid';
import { AnyCredentialRedemptionRequestProviderParams } from '~api/helpers/types';
import { ApiWrapperService } from '~api/openapi/api-wrapper.service';
import { OpenapiHttpContext } from '~api/openapi/openapi.http-context';
import { confirmCredentialRedemption } from '~generated-api/fn/web-provision-credentials-redemption/confirm-credential-redemption';
import { infoCredentialRedemption } from '~generated-api/fn/web-provision-credentials-redemption/info-credential-redemption';
import { initiateCredentialRedemption } from '~generated-api/fn/web-provision-credentials-redemption/initiate-credential-redemption';
import { verifyCredentialRedemption } from '~generated-api/fn/web-provision-credentials-redemption/verify-credential-redemption';
import { CredentialRedemptionType } from '~generated-api/models/credential-redemption-type';

@Injectable({
  providedIn: 'root'
})
export class CredentialService extends ApiWrapperService {
  private deviceId: string;
  private readonly window: Window = inject<Window>(WINDOW);

  constructor() {
    super();
    const session = this.window.sessionStorage;
    let deviceId = session.getItem('deviceId');
    if (!deviceId) {
      deviceId = uuidv4();
      session.setItem('deviceId', deviceId);
    }
    this.deviceId = deviceId;
  }

  public getCredentialInfo(credentialKey: string) {
    return this.api.invoke(infoCredentialRedemption, {
        body: {
          key: credentialKey,
          deviceId: this.deviceId,
        }
      }, new OpenapiHttpContext())
      .pipe(
        this.catchError()
      );
  }

  public initiateCredentialRedemption(credentialKey: string) {
    return this.api.invoke(initiateCredentialRedemption, {
        body: {
          key: credentialKey,
          deviceId: this.deviceId,
        }
      }, new OpenapiHttpContext())
      .pipe(
        this.catchError()
      );
  }

  public verifyCredentialRedemption(credentialId: string, token: string) {
    return this.api.invoke(verifyCredentialRedemption, {
        id: credentialId,
        body: {
          token: token,
          deviceId: this.deviceId,
        }
      }, new OpenapiHttpContext())
      .pipe(
        this.catchError()
      );
  }

  public confirmCredentialRedemption(credentialId: string, redeemType: CredentialRedemptionType, params: AnyCredentialRedemptionRequestProviderParams = undefined) {
    return this.api.invoke(confirmCredentialRedemption, {
        id: credentialId,
        body: {
          types: [redeemType],
          providerParams: params,
          deviceId: this.deviceId,
        }
      }, new OpenapiHttpContext())
      .pipe(
        this.catchError()
      );
  }
}
